/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Url_InvalidInputs */



/**
* | output |
* | --- |
* | "Enter a full address starting with http:// or https://" |
*
* @param {Community_Link_Url_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_url_invalid = /** @type {((inputs?: Community_Link_Url_InvalidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Url_InvalidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez une adresse complète commençant par http:// ou https://")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduce una dirección completa que empiece por http:// o https://")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite um endereço completo começando com http:// ou https://")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un indirizzo completo che inizi con http:// o https://")
	return /** @type {LocalizedString} */ ("Enter a full address starting with http:// or https://")
});